import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Modal from "../../components/profile-modal";
import { Logo } from "../../core/path/images";
import { validateCompleteProfileToken } from "../../core/axios/endpoints";
import { NETWORK_ERROR } from "../../utils/constants";
import PageLoader from "../../components/page-loader";
const CompleteProfilePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const {token} = useParams();
  const [isNetworkError, setIsNetworkError] = useState(false);
  const [isError, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    validateToken();
  }, [location]);


  const validateToken = async () => {
    try {
      await validateCompleteProfileToken({ token });
      setIsModalOpen(true);
    } catch (err) {
      setError(true);
      if(err?.isNetworkError){
        setIsNetworkError(true);
      }
    } finally {
      setIsLoading(false);
    }
  }


  if (isLoading) {
    return <PageLoader />;
}

if (isError) {
    return (
        <div className="main-wrapper">
            <div className="error-box">
                <h1>{isNetworkError ? "503" : "404" }</h1>
                <h3 className="h2 mb-3">
                    <i className="fas fa-exclamation-circle" /> {isNetworkError ? "Network Error!" : " Invalid or Expired Link!"}
                </h3>
                <p className="h4 font-weight-normal mt-2">
                    {isNetworkError ? NETWORK_ERROR : "you link has been expired or invalid, please contact your admin."}
                </p>

            </div>
        </div>
    );
}


  return (
    <div className="main-wrapper flex min-h-screen flex-col items-center justify-center bg-sunken px-4 py-12">
      <div className="mb-8">
        <img src={Logo} alt="Logo" className="h-10 w-auto" />
      </div>
      <div className="w-full max-w-[400px] rounded bg-white p-8 text-center shadow-card">
        <h1 className="text-xl font-medium text-ink">Complete Your Profile</h1>
        <p className="mt-2 text-sm text-ink-subtlest">
          Please complete your profile information to proceed.
        </p>
        <button
          onClick={() => setIsModalOpen(true)}
          className="mt-6 inline-flex h-8 items-center justify-center rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover"
        >
          Complete Now
        </button>
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}  isCompleteProfile={true} token={token} />
      )}
    </div>
  );
};

export default CompleteProfilePage;
